export enum LimitationsCodeNames {
	StorePlans = 'ph-plan-limit',
	Planograms = 'ph-planogram-limit',
	Products = 'ph-product-limit',
	PlanogramCompletionsDownload = 'ph-planogram-download-limit'
}